import { images } from "../constants/images";
import { Link } from "react-router-dom";

const FaqItem = ({ faq, index, visibleAns, setVisibleAns }) => {
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  return (
    <>
      <div
        style={{
          marginBottom: 15,
          marginTop: 15,
          paddingBottom: 15,
          borderBottom: "1px solid rgba(25, 25, 25, 0.1)",
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div className="service-icon" style={{ width: "7%" }}>
            <div
              className="d-flex align-items-center"
              style={{ height: "100%" }}
            >
              <Link
                onClick={() => {
                  setVisibleAns(visibleAns === index ? null : index);
                }}
              >
                <img
                  src={visibleAns === index ? images.minus : images.plus}
                  style={{ height: 30, width: 30 }}
                />
              </Link>
            </div>
          </div>
          <div className="ps-0" style={{ width: "88%" }}>
            <h3
              className="service-title faq-question text-sm-start"
              style={{ fontSize: 27, cursor: "pointer" }}
            >
              <Link

                style={{ textDecoration: "none", color: "#000", borderBottom: "none", fontFamily: "MercurySSm-Book-Pro_Web, serif" }}
                onClick={() => {
                  setVisibleAns(visibleAns === index ? null : index);
                }}
              >
                {faq.question}
              </Link>
            </h3>
          </div>
        </div>
        {visibleAns === index && (
          <>
            <div style={{ marginTop: 10, marginLeft: "10%", textAlign: "start" }}>
              <p style={{ fontSize: 22, marginBottom: 0 }}>{faq.answer}</p>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default FaqItem;
